import React, { useState, useRef, useEffect } from 'react';
import Head from 'next/head';
import Axios from 'axios';
import MasonryInfiniteScroller from 'react-masonry-infinite';
import getMetaTagData from '../../../src/common/services/getMetaTagData';

import Box1 from '../../../src/component/pc/hotissue/box/Box1';
import Box2 from '../../../src/component/pc/hotissue/box/Box2';
import Box3 from '../../../src/component/pc/hotissue/box/Box3';
import Box4 from '../../../src/component/pc/hotissue/box/Box4';
import Box5 from '../../../src/component/pc/hotissue/box/Box5';
import Box6 from '../../../src/component/pc/hotissue/box/Box6';
import Box7 from '../../../src/component/pc/hotissue/box/Box7';
import Loading from '../../../src/component/pc/common/Loading';
import shortid from 'shortid';
import cookieCutter from 'cookie-cutter';

/**
 *
 * <핫이슈 라이브러리사용 목록>
 * - 편의상 1 depth 시작 부분인 현재 위치에서 문서 정리함
 *  1. https://github.com/skoob13/react-masonry-infinite
 *  2. https://github.com/video-dev/hls.js/
 *
 * https://codesandbox.io/s/glyz4?file=/src/index.js:1125-1582
 *
 * 이슈처리 box 에서  .gif 실행 되는경우들은  next image 말고   일반 image 태그 사용해야함 람다 엣지에서 1메가 이상 이미지 지원안함
 *
 */
function HotIssue({
  hotIssueData,
  hotIssueBookmarkData,
  hotIssueSubscribeData,
  metaTagData,
}) {
  //jwt 토큰 관리
  const [login_jwt, setLogin_jwt] = useState();
  const [platform, setPlatform] = useState();

  const [hotIssueDataList, setHotIssueDataList] = useState(hotIssueData.list); //전체 페이지 데이터
  const [introPopChk, setIntroPopChk] = useState();

  const [nextPage, setNextPage] = useState(hotIssueData.next_page); // 현재 페이징 카운트
  const [endPage, setEndPage] = useState(hotIssueData.end_page); // 마지막 페이징 카운트
  const [eventCheck, setEventCheck] = useState(true); // 페이징 계속 해야할때 true  아닐시 false 라이브러리 스크롤 부분 이벤트 체킹 영역
  const itemsPerPage = hotIssueData.length;
  const [records, setrecords] = useState(itemsPerPage);

  const refMasonry = useRef(null);

  const sizes = [{ columns: 3, gutter: 0 }];

  //설명 팝업 닫는 함수
  function popUpClose() {
    document.getElementById('banner').style.display = 'none';
    localStorage.setItem('hotIssueNewIntroPopChk_PC', 'Y');
    setIntroPopChk('Y');
    document.body.classList.remove('body_scroll_none');
  }

  function forceUpdate(params) {
    if (refMasonry.current?.forceUpdate) {
      refMasonry.current.forcePack();
    }
  }

  function showItems() {
    const items = [];
    let subscribeCount = 0;

    for (let index = 0; index < hotIssueDataList.length; index++) {
      let bookMarkStateCheck = false;
      let SubscribeStateCheck = false;
      let bookMarkId = '';
      let SubscribeId = '';

      if (hotIssueBookmarkData != null) {
        for (let index2 = 0; index2 < hotIssueBookmarkData.length; index2++) {
          if (
            hotIssueDataList[index].link_url ==
            hotIssueBookmarkData[index2].link_url
          ) {
            bookMarkStateCheck = true;
            bookMarkId = hotIssueBookmarkData[index2];
          }
        }
      }

      if (hotIssueSubscribeData.items != null) {
        subscribeCount = hotIssueSubscribeData.items.length;
        for (
          let index2 = 0;
          index2 < hotIssueSubscribeData.items.length;
          index2++
        ) {
          if (
            hotIssueDataList[index].programid ==
            hotIssueSubscribeData.items[index2].pgm_id
          ) {
            //programid    pgm_id
            SubscribeStateCheck = true;
            SubscribeId = hotIssueDataList[index].programid;
          }
        }
      }

      switch (hotIssueDataList[index].type) {
        case 1:
          items.push(
            <div key={shortid.generate()} className="hotissue_list_inner">
              <div className="hotissue_list_inner_space">
                <Box1
                  view
                  {...hotIssueDataList[index]}
                  bookMarkState={bookMarkStateCheck}
                  subscribeState={SubscribeStateCheck}
                  key={index}
                  subscribeid={SubscribeId}
                  bookMarkid={bookMarkId}
                  platform={platform}
                  subscribeCountCheck={subscribeCount}
                />
              </div>
            </div>
          );
          break;
        case 2:
          items.push(
            <div key={shortid.generate()} className="hotissue_list_inner">
              <div className="hotissue_list_inner_space">
                <Box2
                  view
                  {...hotIssueDataList[index]}
                  bookMarkState={bookMarkStateCheck}
                  subscribeState={SubscribeStateCheck}
                  key={index}
                  subscribeid={SubscribeId}
                  bookMarkid={bookMarkId}
                  platform={platform}
                  subscribeCountCheck={subscribeCount}
                />
              </div>
            </div>
          );
          break;
        case 3:
          items.push(
            <div key={shortid.generate()} className="hotissue_list_inner">
              <div className="hotissue_list_inner_space">
                <Box3
                  view
                  {...hotIssueDataList[index]}
                  key={index}
                  bookMarkState={bookMarkStateCheck}
                  subscribeState={SubscribeStateCheck}
                  forceUpdate={forceUpdate}
                  subscribeid={SubscribeId}
                  bookMarkid={bookMarkId}
                  platform={platform}
                  subscribeCountCheck={subscribeCount}
                />
              </div>
            </div>
          );
          break;
        case 4:
          items.push(
            <div key={shortid.generate()} className="hotissue_list_inner">
              <div className="hotissue_list_inner_space">
                <Box4
                  view
                  {...hotIssueDataList[index]}
                  key={index}
                  bookMarkState={bookMarkStateCheck}
                  subscribeState={SubscribeStateCheck}
                  forceUpdate={forceUpdate}
                  subscribeid={SubscribeId}
                  bookMarkid={bookMarkId}
                  platform={platform}
                  subscribeCountCheck={subscribeCount}
                />
              </div>
            </div>
          );
          break;
        case 5:
          items.push(
            <div key={shortid.generate()} className="hotissue_list_inner">
              <div className="hotissue_list_inner_space">
                <Box5
                  view
                  {...hotIssueDataList[index]}
                  key={index}
                  bookMarkState={bookMarkStateCheck}
                  subscribeState={SubscribeStateCheck}
                  subscribeid={SubscribeId}
                  bookMarkid={bookMarkId}
                  platform={platform}
                  subscribeCountCheck={subscribeCount}
                />
              </div>
            </div>
          );
          break;
        case 6:
          // items.push(
          //   <div key={shortid.generate()} className='hotissue_list_inner'>
          //     <div className='hotissue_list_inner_space'>
          //       <Box6 view {...hotIssueDataList[index]} key={index} bookMarkState={bookMarkStateCheck} subscribeState={SubscribeStateCheck} subscribeid={SubscribeId} bookMarkid={bookMarkId} platform={platform} subscribeCountCheck={subscribeCount} />
          //     </div>
          //   </div>
          // );
          break;
        case 7:
          items.push(
            <div key={shortid.generate()} className="hotissue_list_inner">
              <div className="hotissue_list_inner_space">
                <Box7
                  view
                  {...hotIssueDataList[index]}
                  key={index}
                  bookMarkState={bookMarkStateCheck}
                  subscribeState={SubscribeStateCheck}
                  forceUpdate={forceUpdate}
                  subscribeid={SubscribeId}
                  bookMarkid={bookMarkId}
                  platform={platform}
                  subscribeCountCheck={subscribeCount}
                />
              </div>
            </div>
          );
          break;
        default:
          // items.push(
          //   <div key={shortid.generate()} className='hotissue_list_inner'>
          //     <div className='hotissue_list_inner_space'>
          //       <Box6 view {...hotIssueDataList[index]} bookMarkState={bookMarkStateCheck} key={index} subscribeState={SubscribeStateCheck} subscribeid={SubscribeId} bookMarkid={bookMarkId} platform={platform} subscribeCountCheck={subscribeCount} />
          //     </div>
          //   </div>
          // );
          break;
      }
    } //finish 1depth for

    return items;
  }

  // 그리드 라이브러리에서 스크롤 끝날시 다음 페이지 호출해주는 부분
  const loadMore = () => {
    const config = {
      method: 'get',
      url:
        'https://static.cloud.sbs.co.kr/2021main/hotIssue/' +
        nextPage +
        '.json', //상용
      // url: 'https://sbsmain-2018.developers.sbs.co.kr/json/2021-test/hotIssue/' + nextPage + '.json', //테스트
      timeout: 3000,
    };

    Axios(config)
      .then(function (response) {
        setNextPage(response.data.next_page);
        setEndPage(response.data.end_page);

        setrecords(records + response.data.list.length);
        const newArr = hotIssueDataList.concat(response.data.list);
        setHotIssueDataList(newArr);

        const comparePage = nextPage - 1;
        if (endPage === comparePage) {
          setEventCheck(false);
        }
      })
      .catch(function (error) {
        console.error(error);
        setEventCheck(false);
      })
      .finally(() => {});
  };

  //화면시작시 최초 한번 시작...
  useEffect(() => {
    window.scrollTo(0, 0);
    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');

    setLogin_jwt(LOGIN_JWT);
    setPlatform(platformCookie);
  }, []);

  useEffect(() => {
    if (localStorage.getItem('hotIssueNewIntroPopChk_PC') == null) {
      document.getElementById('banner').style.display = '';
      document.body.classList.add('body_scroll_none');
      setIntroPopChk('N');
    } else {
      setIntroPopChk('Y');
    }
  }, [introPopChk]);

  return (
    <>
      <Head>
        <link
          key="css_pc_url"
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1"
        />
        <script
          key="gnb_js_url"
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />
        <script src="//developers.kakao.com/sdk/js/kakao.min.js" />
        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        8
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents_hotissue">
        <div className="hotissue_listcontents_wrap">
          <h2 className="hide">핫이슈</h2>

          <div className="contents_area_hotissue">
            <MasonryInfiniteScroller
              pack={true}
              sizes={sizes}
              pageStart={0} // 페이지 스타트
              hasMore={eventCheck}
              loadMore={loadMore}
              loader={<Loading key={shortid.generate()} />} // 로딩 컴포넌트 호출
              ref={refMasonry}
            >
              {showItems()}
            </MasonryInfiniteScroller>
            <div className="contents_side_ad sideAd_right">
              <div className="side_ad_inner">
                <iframe
                  title="배너광고"
                  display="block"
                  src="/html/pc/hotissue_right.htm"
                  width="120px"
                  height="600px"
                  scrolling="no"
                  frameBorder="0"
                  align="middle"
                  marginWidth="0"
                  marginHeight="0"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="banner"
        className="fixed_banner_hotissue"
        style={{ display: 'none' }}
      >
        <div className="fixed_banner_inner">
          <img
            className="fixed_banner_image"
            src="/images/hotissue/pc/hotissue_popup_img.png"
            alt="핫이슈 신규 기능 안내, 내가 좋아하는 콘텐츠만 모아서 즐기세요! new 좋아하는 프로그램 구독하기, new 좋아하는 콘텐츠 찜하기"
          />
          <div className="fixed_banner_btns">
            <button
              type="button"
              className="fixed_banner_btn_closed"
              onClick={() => popUpClose()}
            >
              <span className="fixed_banner_icon_closed">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="10"
                  height="10"
                  viewBox="0 0 10 10"
                >
                  <path
                    className="a"
                    d="M12.17,1.271.521,1.434A.572.572,0,0,1,0,.806H0A.612.612,0,0,1,.538.163L12.188,0a.572.572,0,0,1,.521.628h0A.612.612,0,0,1,12.17,1.271Z"
                    transform="translate(1.014 0) rotate(45)"
                  />
                  <path
                    className="a"
                    d="M12.17.163.521,0A.572.572,0,0,0,0,.628H0a.612.612,0,0,0,.538.643l11.649.163a.572.572,0,0,0,.521-.628h0A.612.612,0,0,0,12.17.163Z"
                    transform="translate(10 1.014) rotate(135)"
                  />
                </svg>
              </span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

// 확인해서 봐야하는 부분은 18개 이상부터 페이징 있음(하위 컴포넌트에서 스크롤 체킹해서 호출해야하는지 확인필요함)
// api 호출하는 부분
export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;
  const { JOIN_PLATFORM } = cookies;
  const { pageSection, pageCategory } = ctx.query;
  let metaTagData;
  let hotIssueData;
  let hotIssueBookmarkData;
  let hotIssueSubscribeData;

  try {
    metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
    hotIssueData = await hotIssueDataList();
    hotIssueBookmarkData = await hotIssueBookmarkDataList(
      LOGIN_JWT,
      JOIN_PLATFORM
    );
    hotIssueSubscribeData = await hotIssueSubscribeDataList(
      LOGIN_JWT,
      JOIN_PLATFORM
    );
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      hotIssueData,
      hotIssueBookmarkData,
      hotIssueSubscribeData,
      metaTagData,
    },
  };
}

const hotIssueDataList = async () => {
  try {
    const hotIssueList = await Axios.get(
      'https://static.cloud.sbs.co.kr/2021main/hotIssue/0.json',
      { timeout: 3000 }
    ); // 상용 진행하는 url
    // const hotIssueList = await Axios.get('https://sbsmain-2018.developers.sbs.co.kr/json/2021-test/hotIssue/0.json', { timeout: 3000 }); // 테스트로 진행하는 url
    const hotIssueData = hotIssueList.data;
    return hotIssueData;
  } catch (e) {
    console.error(e);
  }
};

//찜
const hotIssueBookmarkDataList = async (LOGIN_JWT, JOIN_PLATFORM) => {
  if (LOGIN_JWT == null) {
    const hotIssueBookmarkData = [0];
    return hotIssueBookmarkData;
  }

  try {
    const HotIssueBookmarkData = await Axios.get(
      'https://apis.sbs.co.kr/allvod-api/subscription_list?jwt-token=' +
        LOGIN_JWT +
        '&data_all=y' +
        '&platform=' +
        JOIN_PLATFORM,
      { timeout: 3000 }
    ); // 상용 진행하는 url
    const Data = HotIssueBookmarkData.data.items;
    return Data;
  } catch (e) {
    console.error(e);
  }
};

//구독
const hotIssueSubscribeDataList = async (LOGIN_JWT, JOIN_PLATFORM) => {
  if (LOGIN_JWT == null) {
    const hotIssueSubscribeData = [0];
    return hotIssueSubscribeData;
  }

  try {
    const HotIssueSubscribeData = await Axios.get(
      'https://apis.sbs.co.kr/allvod-api/subscription_pgm_list?jwt-token=' +
        LOGIN_JWT +
        '&platform=' +
        JOIN_PLATFORM,
      { timeout: 3000 }
    ); // 상용 진행하는 url
    const Data = HotIssueSubscribeData.data;
    return Data;
  } catch (e) {
    console.error(e);
  }
};

export default HotIssue;
